import React from 'react';
import { Chip } from '@mui/material';
import { CheckCircleOutline, HourglassEmpty, Cancel as CancelIcon, ScheduleSend } from '@mui/icons-material';
import { ApprovalUiStatus } from '../../../services/ApprovalService';

interface ApprovalStatusChipProps {
  status: ApprovalUiStatus;
}

const ApprovalStatusChip: React.FC<ApprovalStatusChipProps> = ({ status }) => {
  switch (status) {
    case 'approved':
      return <Chip size="small" color="success" icon={<CheckCircleOutline />} label="Approved" />;
    case 'rejected':
      return <Chip size="small" color="error" icon={<CancelIcon />} label="Rejected" />;
    case 'expired':
      return <Chip size="small" color="warning" icon={<ScheduleSend />} label="Expired" />;
    default:
      return <Chip size="small" color="info" icon={<HourglassEmpty />} label="Pending" />;
  }
};

export default ApprovalStatusChip;
